export default __webpack_public_path__ + "static/media/2020-plan-2.26eb03ae.jpeg";